import { render, staticRenderFns } from "./ComparisonBadge.vue?vue&type=template&id=231ff0d1&scoped=true"
import script from "./ComparisonBadge.vue?vue&type=script&lang=js"
export * from "./ComparisonBadge.vue?vue&type=script&lang=js"
import style0 from "./ComparisonBadge.vue?vue&type=style&index=0&id=231ff0d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231ff0d1",
  null
  
)

export default component.exports